(function() {
    const initZoomImageViewer = function (viewport) {
        const ImageZoom = function (viewport, maxScale, scaleStep) {
            this.viewport = viewport;
            this.imageContainer = viewport.querySelector('[data-image-zoom-image]');
            this.buttonZoomIn = viewport.querySelector('[data-image-zoom-button-zoom-in]');
            this.buttonZoomOut = viewport.querySelector('[data-image-zoom-button-zoom-out]');
            this.image = this.imageContainer.querySelector('img');

            this.maxScale = maxScale || 2;
            this.minScale = 1;
            this.scaleStep = scaleStep || 1.5;

            this.scale = 1;
            this.offsetLeft = 0.5;
            this.offsetTop = 0.5;

            const settings =JSON.parse(viewport.getAttribute('data-image-zoom'));

            if(!settings.touchDisabled || matchMedia('(pointer:fine)').matches){
                this.configurePointerListeners();
            }else{
                this.buttonZoomIn.style.display='none';
                this.buttonZoomOut.style.display='none';
            }
            this.configureListeners();
        };
        const fn = ImageZoom.prototype;
        fn.setContainerStyles = function(){
            const o = this;
            o.imageContainer.style.width = (o.image.naturalWidth * o.scale) + 'px';
            o.imageContainer.style.height = (o.image.naturalHeight * o.scale) + 'px';

            o.imageContainer.style.left = ((o.viewport.offsetWidth - o.image.naturalWidth * o.scale) * o.offsetLeft) + 'px';
            o.imageContainer.style.top = ((o.viewport.offsetHeight - o.image.naturalHeight * o.scale) * o.offsetTop) + 'px';
        };
        fn.render = function(){
            const o = this;
            if(o.image.naturalWidth * o.scale <= o.viewport.offsetWidth ){
                o.offsetLeft = 0.5;
            }
            if(o.image.naturalHeight * o.scale <= o.viewport.offsetHeight ){
                o.offsetTop = 0.5;
            }
            o.setContainerStyles();
            o.setButtonsStatus();
        };
        fn.setTransition = function(value){
            this.imageContainer.style.transition = !!value ? 'all 0.4s' : 'none';
        };
        fn.setButtonsStatus = function () {
            const o = this;
            if (o.scale === o.maxScale) {
                o.buttonZoomIn.classList.add('disabled');
            } else {
                o.buttonZoomIn.classList.remove('disabled');
            }
            if (o.scale === o.minScale) {
                o.buttonZoomOut.classList.add('disabled');
            } else {
                o.buttonZoomOut.classList.remove('disabled');
            }
        };
        fn.scaleTo = function (value) {
            this.scale = value;
            this.render();
        };
        fn.moveTo = function (left, top) {
            this.offsetLeft = left;
            this.offsetTop = top;
            this.render();
        };
        fn.limitValue = function (value, min, max) {
            return value < min ? min : (value > max ? max : value)
        };
        fn.calcMinScale = function(){
            this.minScale = Math.min(
                this.viewport.offsetWidth / this.image.naturalWidth,
                this.viewport.offsetHeight / this.image.naturalHeight
            );
        };
        fn.resetSizes = function () {
            this.calcMinScale();
            this.setTransition(false);
            this.scale = this.minScale;
            this.scaleTo(this.scale);
        };
        fn.initSizes = function () {
            this.calcMinScale();
            this.setTransition(false);
            this.scaleTo(this.minScale);
        };
        fn.configurePointerListeners = function(){
            const o = this;
            o.imageContainer.addEventListener('mousedown', function (e) {
                e.preventDefault();
                const delta = {
                    x: e.clientX - parseInt(o.imageContainer.style.left),
                    y: e.clientY - parseInt(o.imageContainer.style.top)
                };
                o.setTransition.call(o, false);
                const onDrag = (e) => {
                    o.moveTo.call(o,
                        o.limitValue((e.clientX - delta.x) / (o.viewport.offsetWidth - o.imageContainer.offsetWidth), 0, 1),
                        o.limitValue((e.clientY - delta.y) / (o.viewport.offsetHeight - o.imageContainer.offsetHeight) , 0, 1)
                    )
                };
                const onDragEnd = () => {
                    window.removeEventListener('mousemove', onDrag);
                    window.removeEventListener('mouseup', onDragEnd);
                    o.setTransition.call(o, true);
                };

                window.removeEventListener('mousemove', onDrag);
                window.removeEventListener('mouseup', onDragEnd);

                window.addEventListener('mousemove', onDrag);
                window.addEventListener('mouseup', onDragEnd);
            });
            o.imageContainer.addEventListener('touchstart', function (e) {
                const dragDelta = {};
                const onDragStart = (e) => {
                    if(e.touches.length === 1){
                        const touch = e.touches[e.touches.length -1];
                        dragDelta. x = touch.clientX - parseInt(o.imageContainer.style.left);
                        dragDelta.y = touch.clientY - parseInt(o.imageContainer.style.top);

                        o.setTransition.call(o, false);
                        window.removeEventListener('touchmove', onDrag);
                        window.removeEventListener('touchend', onDragEnd);

                        window.addEventListener('touchmove', onDrag, {passive: false});
                        window.addEventListener('touchend', onDragEnd);
                    }else{
                        onDragEnd();
                    }
                };
                const onDrag = (e) => {
                    if(o.scale !== o.minScale){
                        e.preventDefault();
                        const touch = e.touches[e.touches.length -1];
                        const nextOffsetLeft = o.limitValue((touch.clientX - dragDelta.x) / (o.viewport.offsetWidth - o.imageContainer.offsetWidth), 0, 1);
                        const nextOffsetTop = o.limitValue((touch.clientY - dragDelta.y) / (o.viewport.offsetHeight - o.imageContainer.offsetHeight), 0, 1);
                        o.moveTo.call(o, nextOffsetLeft,nextOffsetTop);
                    }
                };
                const onDragEnd = () => {
                    window.removeEventListener('touchmove', onDrag);
                    window.removeEventListener('touchend', onDragEnd);
                    window.removeEventListener('touchstart', onDragStart);
                    o.setTransition.call(o, true);
                };
                window.removeEventListener('touchstart', onDragStart);
                window.addEventListener('touchstart', onDragStart);
            });
            o.buttonZoomIn.addEventListener('click', () => {
                o.setTransition.call(o, true);
                o.scaleTo.call(o,Math.min(o.maxScale, o.scale * o.scaleStep));
            });
            o.buttonZoomOut.addEventListener('click', () => {
                o.setTransition.call(o, true);
                o.scaleTo.call(o,Math.max(o.scale / o.scaleStep, o.minScale));
            });
        };
        fn.configureListeners = function(){
            const o = this;
            const _onload = o.image.onload || function () {
            };
            o.image.onload = function () {
                o.initSizes.call(o);
                _onload.call(this);
            };
            o.image.addEventListener('resize', function(){
                o.resetSizes.call(o);
            })
            /*
            let timeout = 0;
            window.addEventListener('resize', function () {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    o.resetSizes.call(o);
                    setTimeout(function(){
                        o.resetSizes.call(o);
                    }, 100);
                }, 100);
            });
            */
        };

        new ImageZoom(viewport, 2, 1.5);
    };

    window.addEventListener('load', function () {
        document.querySelectorAll('[data-image-zoom]').forEach(initZoomImageViewer);
    });
})();
